<template>
  <div
    itemscope=""
    itemtype="https://schema.org/Organization"
  >
    <div>
      <div class="container">
        <div class="row">
          <div
            v-if="directusContent.title"
            class="col-12"
          >
            <h1
              v-dompurify-html="directusContent.title"
              class="mb-0"
            />
          </div>
          <div
            v-if="directusContent.contentbox_1"
            v-dompurify-html="directusContent.contentbox_1"
            class="col-md-6"
          />
          <div
            v-if="directusContent.contentbox_2"
            v-dompurify-html="directusContent.contentbox_2"
            class="col-md-6"
          />
          <div
            v-if="directusContent.contentbox_3"
            v-dompurify-html="directusContent.contentbox_3"
            class="col-md-6"
          />
          <div
            v-if="directusContent.contentbox_4"
            v-dompurify-html="directusContent.contentbox_4"
            class="col-md-6"
          />
          <div
            v-if="directusContent.contentbox_5"
            v-dompurify-html="directusContent.contentbox_5"
            class="col-md-6"
          />
          <div
            v-if="directusContent.contentbox_6"
            v-dompurify-html="directusContent.contentbox_6"
            class="col-md-12"
          />
        </div>
      </div>
      <error-500-content
        v-if="directusError"
      />
    </div>
  </div>
</template>

<script>
import Error500Content from 'components/errors/Error500Content.vue';
import CMSData from 'mixins/CMSData';
import config from 'config/appConfig';

const { disclaimer: i18nOptions } = config;

export default {
  name: 'Disclaimer',
  components: {
    Error500Content,
  },
  ...i18nOptions,
  mixins: [CMSData],
  data() {
    return {
      cmsError: false,
      cmsParams: {
        collection: 'landingpage',
        pageAlias: 'disclaimer',
        fields: [
          'json_meta',
          'title',
          'contentbox_1',
          'contentbox_2',
          'contentbox_3',
          'contentbox_4',
          'contentbox_5',
          'contentbox_6',
        ],
      },
    };
  },
  computed: {
    additionalMeta() {
      return {
        script: [
          {
            type: 'application/ld+json',
            json: this.directusContentMeta?.structuredData || '',
            vmid: 'structuredDataOrganizationJson',
          },
        ],
      };
    },
  },
};
</script>
